import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import {
  NgbCarousel,
  NgbCarouselConfig,
  NgbModal,
} from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/Service/auth.service';
import { JsonldService } from 'src/app/Service/jsonld.service';
import { LoadingService } from 'src/app/Service/loading.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { UserService } from 'src/app/User/Service/user.service';
import { GlobalConstants } from 'src/app/utils/global-constants';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.css'],
    providers: [NgbCarouselConfig],
    standalone: false
})
export class LandingComponent implements OnInit, OnDestroy {
  @ViewChild('carousel') carousel: NgbCarousel;
  subscription = new Subscription();
  @ViewChild('pricing') pricing;
  emailForm: FormGroup;
  constructor(
    public auth: AuthService,
    public userService: UserService,
    private loader: LoadingService,
    private router: Router,
    private modalService: NgbModal,
    config: NgbCarouselConfig,
    public route: ActivatedRoute,
    private jsonldService: JsonldService,
    private meta: Meta,
    private notify: NotificationService,
    private formBuilder: FormBuilder
  ) {
    this.meta.addTags([
      {
        name: 'description',
        content:
          'Keep your family organized and prepared for the future with Family Central suite of tools for financial planning, protecting vital documents, preserving family history, and more.',
      },
      {
        name: 'facebook-domain-verification',
        content: 's1qdl99juofeqquxvqd4phf9dxl6ca',
      },
    ]);

    config.interval = 2000;
    config.pauseOnHover = false;
    config.wrap = false;
    config.keyboard = false;
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  ngOnInit(): void {
    this.emailForm = this.formBuilder.group({
      email: [
        '',
        [Validators.required, Validators.pattern(GlobalConstants.emailPattern)],
      ],
    });
    if (this.userService.isLoggedin) {
      if (
        this.userService.authUserInfo[GlobalConstants.roleClaim] == 'Executor'
      )
        this.router.navigateByUrl('/executor');
      else if (
        this.userService.authUserInfo[GlobalConstants.roleClaim] ==
        'Financial Planner'
      )
        this.router.navigateByUrl('/authprofessional');
      else this.router.navigateByUrl('/user');
    } else {
      this.loader.HideLoading();
    }
    if (this.router.url === '/ourstory') {
      setTimeout(function () {
        document.getElementById('ourStory').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }, 1);
    }
    this.subscription.add(
      this.route.queryParams.subscribe((resp) => {
        if (resp?.referral) {
          sessionStorage.setItem('referalEnd', resp.end);
          sessionStorage.setItem('referalId', resp.referral);
        }
      })
    );
  }

  goToOnboard() {
    if (this.emailForm.valid) {
      const navigationExtras: NavigationExtras = {
        state: {
          email: this.emailForm.get('email').value,
        },
      };
      this.router.navigateByUrl('/signup-type', navigationExtras);
    } else {
      this.notify.showWarning('Please fill in the email field.');
    }
  }
  onClose() {
    this.modalService.dismissAll();
  }

  setJsonLdSchema() {
    const jsonLdData = {
      '@context': 'https://schema.org/',
      '@type': 'WebSite',
      name: 'FamilyCentral',
      url: ' https://familycentral.com/',
      sourceOrganization: {
        '@type': 'Organization',
        name: ' FamilyCentral ',
      },
    };

    this.jsonldService.setJsonLdData(jsonLdData);
  }
}
